import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const tabsContext = createContext(null);
export function useTabsContext() {
    const context = useContext(tabsContext);
    if (context === null) {
        throw new Error('TabsContext was not found');
    }
    return context;
}
export function TabsProvider(props) {
    return (_jsx(tabsContext.Provider, { value: props.opened, children: props.children }));
}
//# sourceMappingURL=TabsContext.js.map